import { createContext } from 'react';

import type { InboxConnection } from './inbox-socket';

export interface InboxLive {
  connection: InboxConnection;
  /** True when lists and threads must poll (socket failed, or the member is invisible). */
  polling: boolean;
  /** Follow a thread: replays what the cache misses, then relays it live. */
  follow: (storeId: string, conversationId: string) => () => void;
  /** The thread on screen; alerts stay quiet for it while the tab is visible. */
  setActive: (conversationId: string | null) => void;
  /** False when no socket is live; the caller then uses REST (read) or skips (typing). */
  sendTyping: (conversationId: string, internal: boolean) => boolean;
  sendRead: (conversationId: string, upToMessageId: string) => boolean;
}

/** Outside an inbox the page still works: it polls and sends reads over REST. */
export const OFFLINE_LIVE: InboxLive = {
  connection: 'off',
  polling: true,
  follow: () => () => undefined,
  setActive: () => undefined,
  sendTyping: () => false,
  sendRead: () => false,
};

export const InboxLiveContext = createContext<InboxLive>(OFFLINE_LIVE);
